// extracted by mini-css-extract-plugin
module.exports = {"bannerVideo":"Home_bannerVideo__2XFT9","bannerImage":"Home_bannerImage__69BIn","banner1":"Home_banner1__2RXZ1","banner2":"Home_banner2__3Xw-u"};